import fragmentTimestampToDate from './fragmentTimestampToDate';

export default fragmentTimestampToDate;
